import React, { useState } from "react";
import Collapse from "../../../components/Collapse";
import { formatBook } from "../../../utils/formatOdds";

// Reference v-kvalmin / v-kvalmax: 1000 → "1K", 100000 → "1L" (2 decimals, trailing zeros dropped)
function formatRangeVal(val) {
  const n = Number(val);
  if (val == null || val === "" || Number.isNaN(n)) return "";
  if (n >= 100000) return `${parseFloat((n / 100000).toFixed(2))}L`;
  if (n >= 1000) return `${parseFloat((n / 1000).toFixed(2))}K`;
  return String(parseFloat(n.toFixed(2)));
}

/**
 * BetTableTeen33 – Instant Teenpatti (teen3), Instant Teenpatti 2.0 (teen32), Instant Teenpatti 3.0 (teen33).
 * Reference markup (inside .casino-detail of .casino-table.teenpatti1day):
 *   .teen1daycasino-container.d-none-small > .teen1dayleft / .teen1daycenter / .teen1dayright
 *     each side: title row (Player A|B, Back, Lay) + "Main" row (book, (i) range collapse, back/lay odds).
 * Player A = main[0], Player B = main[1] (sub sorted by sr). Suspended when gstatus != "OPEN".
 */
export default function BetTableTeen33({ data = [], onBetClick, exposures = {}, myBets = [] }) {
  const [openRanges, setOpenRanges] = useState({});

  const toggleRange = (id) => {
    setOpenRanges((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const sorted = [...(Array.isArray(data) ? data : [])].sort((x, y) => (Number(x?.sr) || 0) - (Number(y?.sr) || 0));
  const playerA = sorted.find((item) => item?.nat === "Player A") || sorted[0] || {};
  const playerB = sorted.find((item) => item?.nat === "Player B") || sorted[1] || {};

  const getExposure = (selection) => {
    if (!selection) return 0;
    const key = [selection, selection.toLowerCase().trim(), selection.trim()]
      .find((k) => k && exposures[k] !== undefined && exposures[k] !== 0);
    if (key != null) return parseFloat(exposures[key]) || 0;
    const match = myBets.find((b) => {
      const sel = (b.matchedBet || b.selection || b.player_name || "").toLowerCase().trim();
      return sel === selection.toLowerCase().trim();
    });
    if (match && match.exposer !== undefined && match.exposer !== null && match.exposer !== 0)
      return parseFloat(match.exposer) || 0;
    return 0;
  };

  const titleRow = (playerClass, playerName) => (
    <div className="casino-box-row">
      <div className="casino-nation-name no-border casino-bl-box-title">
        <div className={playerClass}>{playerName}</div>
      </div>{" "}
      <div className="casino-bl-box casino-bl-box-title">
        <div className="casino-bl-box-item">
          <b>Back</b>
        </div>{" "}
        <div className="casino-bl-box-item">
          <b>Lay</b>
        </div>
      </div>
    </div>
  );

  const mainRow = (item, playerName, rangeId) => {
    const suspended = item?.gstatus !== "OPEN";
    const exposure = Number(getExposure(item?.nat || playerName)) || 0;
    const isOpen = !!openRanges[rangeId];
    const bet = (type) => {
      const value = type === "back" ? item?.b : item?.l;
      if (suspended || !value) return;
      onBetClick?.(value, "Main", type, { ...item, nat: playerName });
    };

    return (
      <div className="casino-box-row">
        <div className="casino-nation-name">
          <b>Main</b>{" "}
          <div className="float-right">
            {/* Reference v-casinobook: > 0 → book-green, otherwise book-red */}
            <span className={`mr-2 casino-book ${exposure > 0 ? "book-green" : "book-red"}`}>
              {formatBook(exposure)}
            </span>{" "}
            <i
              data-toggle="collapse"
              data-target={`#${rangeId}`}
              aria-expanded={isOpen ? "true" : "false"}
              className={`fas fa-info-circle${isOpen ? "" : " collapsed"}`}
              onClick={() => toggleRange(rangeId)}
            />{" "}
            <Collapse id={rangeId} open={!!isOpen} className="icon-range">
              {"\n                                                    R:"}
              <span>{formatRangeVal(item?.min)}</span>-<span>{formatRangeVal(item?.max)}</span>
            </Collapse>
          </div>
        </div>{" "}
        <div className="casino-bl-box">
          <div className={`back casino-bl-box-item${suspended ? " suspended" : ""}`} onClick={() => bet("back")}>
            <span className="casino-box-odd">{item?.b ?? 0}</span>
          </div>{" "}
          <div className={`lay casino-bl-box-item${suspended ? " suspended" : ""}`} onClick={() => bet("lay")}>
            <span className="casino-box-odd">{item?.l ?? 0}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="teen1daycasino-container d-none-small">
      <div className="teen1dayleft">
        {titleRow("playera", "Player A")} {mainRow(playerA, "Player A", "range1")}
      </div>{" "}
      <div className="teen1daycenter" />{" "}
      <div className="teen1dayright">
        {titleRow("playerb", "Player B")} {mainRow(playerB, "Player B", "range7")}
      </div>
    </div>
  );
}
